import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { roles } from "utils/constant";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon, DocumentDuplicateIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { AfDateRangePicker } from "components/Input/AfDateRangePicker";
import Spinner from "utils/Spinner";
import ViewPickupMail from "./ViewPickupMail";

const CreditReport: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const [tableData, setTableData] = useState<any>([]);
  const [totals, setTotals] = useState<any>({});
  const [agentId, setAgentId] = useState("");
  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));

  const [query, setQuery] = useState<any>({
    date: {
      startDate: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      endDate: moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    },
    /*qry: `date >= '${moment().startOf("day").format("YYYY-MM-DD HH:mm:ss")}' AND date <= '${moment()
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss")}'`,*/
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);

  const [nestedTables, setNestedTables] = useState<any>({});
  const [nestedSelectedOptions, setNestedSelectedOptions] = useState<any>({});

  const [selectedCustomer, setBranchOtp] = useState<any>();
  const [customerList, setcustomerList] = useState<any>([{ value: 0, label: "Loading..." }]);
  const defaultOptions: any = [{ value: 0, label: "Loading..." }];
  const [sortStat, setSortStat] = useState<any>({});

  const [isPopupOpen, setIsPopupOpen] = useState("");

  const {
    error: branchError,
    isFetching: branchIsFetching,
    isError: branchIsError,
    isFetched: branchIsFetched,
    isLoading: branchIsLoading,
    refetch: branchRefetch,
  } = useQuery(["CustomersListApi"], () => ListCommanWay("/admin/customer/list", { isActive: true }, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.code,
            label: p.code + " - " + p.sh,
          });
        });
        setcustomerList(opt);
      }
    },
  });

  const { isFetching, isLoading, refetch } = useQuery(
    ["admin_credit_report_list"],
    () =>
      ListCommanWay(
        "/admin/awbdata/creditreport",
        {
          ...query,
        },
        { include: ["_invoice_no_c_b"] }
      ),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          console.log("data.data", data.data);
          setTableData(data.data);
          setSortStat({});
          let ary = [...data.data];
          let ttt = {
            base: 0,
            cgst: 0,
            sgst: 0,
            igst: 0,
            utgst: 0,
            grand: 0,

            ten_30: 0,
            holiday: 0,
            fuel: 0,
            chc: 0,
            weight: 0,
            diceWt: 0,

            ab: 0,
            dice: 0,
            dg: 0,
            pkg: 0,
            oda: 0,
            other: 0,
          };
          ary.forEach((a) => {
            console.log(a.base_value);
            ttt.base += Number(a["Basic Amount"] || 0);
            ttt.cgst += Number(a["CGST"] || 0);
            ttt.sgst += Number(a["SGST"] || 0);
            ttt.igst += Number(a["IGST"] || 0);
            ttt.grand += Number(a["Grand Total"] || 0);

            ttt.ten_30 += Number(a["10:30"] || 0);
            ttt.holiday += Number(a["Holiday"] || 0);
            ttt.fuel += Number(a["Fuel Surcharge"] || 0);
            ttt.chc += Number(a["CHC Charge"] || 0);
            ttt.weight += Number(a["weight"] || 0);
            ttt.diceWt += Number(a["D-Ice WT"] || 0);

            ttt.ab += Number(a["Awb charge"] || 0);
            ttt.dice += Number(a["Dry Ice"] || 0);
            ttt.dg += Number(a["DG charge"] || 0);
            ttt.pkg += Number(a["PKG charge"] || 0);
            ttt.oda += Number(a["ODA charge"] || 0);
            ttt.other += Number(a["Other charge"] || 0);
          });
          setTotals(ttt);
        } else {
          setTableData([]);
        }
      },
      onError: (data) => {
        setTableData([]);
      },
    }
  );

  useEffect(() => {
    setTotals({ grand: 0 });
    refetch();
  }, [query]);

  const { mutate: mutateRefreshRate } = useMutation(
    () =>
      ListCommanWay(
        "/admin/customer/refresh-rate",
        {
          startDate: startDate ? startDate : moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
          endDate: endDate ? endDate : moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
          customer: selectedCustomer?.value,
        },
        {}
      ),
    {
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          UseToast("Refresh Request Success", "success");
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );
  const RateRefresh = async () => {
    if (!selectedCustomer.value) {
      return;
    }
    Swal.fire({
      title: "Are you sure!",
      icon: "question",
      confirmButtonText: "Confirm",
      showCancelButton: true,
    }).then((x) => {
      if (x.isConfirmed) {
        mutateRefreshRate();
      }
    });
  };

  const __handleSubmit = async () => {
    setIsDataAdded(!isDataAdded);

    setQuery({
      date: {
        startDate: startDate ? startDate : moment().startOf("day").subtract(7, "days").format("YYYY-MM-DD HH:mm:ss"),
        endDate: endDate ? endDate : moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      },
      customer: selectedCustomer?.value,
    });

    /*setQuery({
      //agent_id: Number(agentId),
      date: {
        $gte: startDate ? startDate : moment().startOf("day").subtract(7, "days"),
        $lte: endDate ? endDate : moment().endOf("day"),
      },
    });*/
  };

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const tableRef = useRef(null);

  const exportToExcel = async () => {
    const table = tableRef.current;

    const tableClone = table.cloneNode(true);

    const tfoot = tableClone.getElementsByTagName("tfoot");
    if (tfoot.length > 0) {
      tfoot[0].remove();
    }
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    if (toIgnore.length > 0) {
      toIgnore[0].remove();
    }

    const rows = tableClone.querySelectorAll("tbody tr");
    rows.forEach((row) => {
      const dateCell = row.cells[2]; // Second column is at index 1
      dateCell.innerText = moment(dateCell.innerText, "DD-MM-YYYY").format("YYYY-MM-DD");
    });

    /*const workbook = await XlsxPopulate.fromBlankAsync();
    const sheet = workbook.sheet(0);
    tableClone.querySelectorAll("thead th").forEach((header,index) => {
      sheet.cell(1, index + 1).value(header); // A1, B1, C1, etc.
    });


    tableClone.querySelectorAll("tbody th").forEach((row,rowIndex) => {      
      row.querySelectorAll('td').forEach((cell, colIndex) => {
        sheet.cell(rowIndex + 2, colIndex + 1).value(cell.innerText); // Start from row 2 (after headers)
      });
    });

    return;*/
    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Sheet1");

    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    const wbout = write(wb, { bookType: "xlsx", type: "array" });

    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "Credit Report.xlsx");
  };

  const GET_SORT_ICON = (key, info) => {
    switch (sortStat[key]) {
      case "asc":
        return (
          <ArrowDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      case "desc":
        return (
          <ArrowUpIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
      default:
        return (
          <ArrowsUpDownIcon
            className="h-4 inline-block"
            onClick={() => {
              handleSort(key, info);
            }}
          />
        );
    }
  };

  const handleSort = (key, info) => {
    let data = [...tableData];
    let order = sortStat[key] == "asc" ? "desc" : "asc";

    if (key == "_invoice_no_c_b.isFullPaid") {
      data = data.sort((a, b) => {
        if (order == "asc") {
          return -a["isActive"] + b["isActive"];
        } else {
          return -b["isActive"] + a["isActive"];
        }
      });
    }

    let sortedData = data.sort((a, b) => {
      // Extract the value using the keyPath (e.g., "invoice_data.idpaid")
      const valueA = key.split(".").reduce((obj, key) => obj[key], a);
      const valueB = key.split(".").reduce((obj, key) => obj[key], b);
      // Handle sorting for different data types
      if (valueA < valueB) return order === "asc" ? -1 : 1;
      if (valueA > valueB) return order === "asc" ? 1 : -1;
      return 0; // If equal
    });
    let _sortStat = { ...sortStat };
    _sortStat[key] = order;
    setSortStat(_sortStat);
    setTableData(sortedData);
  };

  return (
    <>
      {(isLoading || isFetching) && <Spinner />}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-black-900 bg-opacity-50 z-50 flex items-center justify-end p-4">
          <div className=" rounded-lg shadow-xl w-full max-w-5xl max-h-[95vh] overflow-y-auto relative">
            {/* Optional Close Button */}
            <button
              className="absolute top-3 right-3 text-black-900 bg-white rounded-md hover:text-gray-700"
              onClick={() => setIsPopupOpen("")}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            {/* Scrollable Content */}
            <div className="pt-2">
              <ViewPickupMail pickup_code={isPopupOpen || ""} />
            </div>
          </div>
        </div>
      )}
      <h1 className="text-center mb-2 mt-2 text-lg font-semibold ">Credit Report</h1>
      <div className="px-4 mb-3 rounded-md">
        <div className="flex flex-col items-center">
          <div className="flex items-center gap-x-4 gap-y-2">
            {(userDetails.role_name == 1 || userDetails.role_name == 10) && (
              <div className={`items-center gap-2`}>
                <label className="mb-2 text-sm font-semibold text-gray-900">Customer</label>
                <Select
                  className={`${false ? "bg-gray-300" : ""} w-72 bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block`}
                  options={customerList}
                  onChange={(e) => {
                    setBranchOtp(e);
                  }}
                  value={selectedCustomer}
                  isClearable={true}
                />
              </div>
            )}

            <AfDateRangePicker setStartDate={setStartDate} setEndDate={setEndDate} label="Date Range" />

            {/*<div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">From Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                placeholder="Start Date"
                name="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="">
              <label className="block mb-0.5 text-sm font-medium text-gray-900">To Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5`}
                placeholder="End Date"
                name="endDate"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>*/}
            <button
              type="button"
              onClick={__handleSubmit}
              className="ml-2 mt-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-green-500 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
            >
              Submit
            </button>
            {userDetails.roleName === roles.SUPER_ADMIN && (
              <button
                type="button"
                onClick={RateRefresh}
                className="ml-0 mt-2 rounded-md px-4 py-2 text-sm font-medium text-white bg-red-700 border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700"
              >
                Rate Refresh
              </button>
            )}

            <div>
              TOTAL:{" "}
              <span style={{ fontWeight: 600, color: "red" }} className="">
                {new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(Number(totals.grand))}
              </span>
            </div>
            <button onClick={exportToExcel} className=" bg-blue-600 text-white px-4 py-1 rounded-md">
              Excel Export
            </button>
          </div>
        </div>
      </div>

      <div className="px-4">
        {tableData && tableData.length && (
          <table className="w-full table- mb-8" style={{ fontSize: "85%" }} id="myTable" ref={tableRef}>
            <thead className="sticky top-0 bg-gray-300">
              <tr>
                <th className="border border-slate-200 px-1">{tableData.length}</th>
                <th className="border border-slate-200 px-1"></th>
                <th className="border border-slate-200 px-1 min-w-[92px]"></th>
                <th className="border border-slate-200 px-1"></th>
                <th className="border border-slate-200 px-1"></th>
                <th className="border border-slate-200 px-1"></th>
                <th className="border border-slate-200 px-1"></th>
                <th className="border border-slate-200 px-1"></th>
                <th className="border border-slate-200 px-1"></th>
                <th className="border border-slate-200 px-1">{totals.weight?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1 min-w-[50px]">{totals.diceWt?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1 py-2">{totals.base?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.holiday?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.ten_30?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.fuel?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.chc?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.ab?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.dice?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.dg?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.pkg?.toFixed(2)}</th>

                <th className="border border-slate-200 px-1">{totals.oda?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.other?.toFixed(2)}</th>

                <th className="border border-slate-200 px-1">{totals.cgst?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.sgst?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{totals.igst?.toFixed(2)}</th>
                <th className="border border-slate-200 px-1">{Number(totals.grand).toFixed(2)}</th>
                <th className="border border-slate-200 px-1"></th>
                <th className="border border-slate-200 px-1"></th>
                <th className="border border-slate-200 px-1"></th>
              </tr>
              <tr>
                <th className="border border-slate-200 px-1">Sr.</th>
                {Object.keys(tableData[0]).map((h) => {
                  return (
                    <th key={"header-" + h} className="border border-slate-200 px-1">
                      {h}
                      {GET_SORT_ICON(h, "asc")}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {tableData.map((r, i) => {
                return (
                  <tr key={"r" + r["AWB"]}>
                    <td className="border border-slate-200 px-2">{i + 1}</td>

                    {Object.keys(r).map((h) => {
                      if (h == "AWB") {
                        return (
                          <td key={"body-" + i + h} className="border border-slate-200 px-1 whitespace-nowrap">
                            <a target="_blank" href={`/pod/tracking?awb=${r[h]}`} className="text-primary2">
                              {r[h]}
                            </a>

                            <button
                              type="button"
                              onClick={async () => {
                                await navigator.clipboard.writeText(r[h] || "-");
                                UseToast("Copied!");
                              }}
                              className="ml-2"
                            >
                              <DocumentDuplicateIcon className="h-5 mr-2" />
                            </button>

                            {r["Pickup Code"] && (
                              <button
                                type="button"
                                onClick={async () => {
                                  setIsPopupOpen(r["Pickup Code"] || "");
                                }}
                                className=""
                              >
                                <EnvelopeIcon className="h-5  mr-2" />
                              </button>
                            )}
                          </td>
                        );
                      } else {
                        return (
                          <td key={"body-" + i + h} className="border border-slate-200 px-1">
                            {r[h]}
                          </td>
                        );
                      }
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
};

export default CreditReport;
